import { useState, useEffect, useRef } from 'react';
import { FaUsers, FaPaintBrush, FaPen, FaMusic, FaCalculator, FaHandshake } from 'react-icons/fa';
import './Leadership.css';

import imgLeaderCover from '../cover/leader cover.jpg';

function Leadership() {
  const [visibleSections, setVisibleSections] = useState(new Set());
  const sectionRefs = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setVisibleSections((prev) => new Set([...prev, entry.target.dataset.section]));
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -50px 0px' }
    );
    sectionRefs.current.forEach((ref) => { if (ref) observer.observe(ref); });
    return () => observer.disconnect();
  }, []);

  const leadership = [
    {
      icon: <FaUsers />,
      position: 'Secretary',
      organization: 'FAITH CpE Society',
      year: '2025 – 2026',
      desc: 'Managing organizational records, documentation, meeting minutes, and coordinating with officers and members.',
      type: 'College Organization'
    },
    {
      icon: <FaPaintBrush />,
      position: 'Media & Graphics Officer',
      organization: 'FAITH CpE Society',
      year: '2024 – 2025',
      desc: 'Handled graphic design, social media content creation, and visual communications for the Computer Engineering Society.',
      type: 'College Organization'
    },
    {
      icon: <FaMusic />,
      position: 'Year Level Representative',
      organization: 'MAPEH Club',
      year: '2019 – 2020',
      desc: 'Led year level participation in MAPEH (Music, Arts, PE, Health) club events and activities.',
      type: 'School Club'
    },
    {
      icon: <FaPen />,
      position: 'Year Level Representative',
      organization: 'Filipino Club',
      year: '2018 – 2019',
      desc: 'Represented the year level in the Filipino Club, coordinating literary and cultural activities.',
      type: 'School Club'
    },
    {
      icon: <FaCalculator />,
      position: 'Year Level Representative',
      organization: 'Math Club',
      year: '2017 – 2018',
      desc: 'Served as year level representative, helping organize math-related activities and events for students.',
      type: 'School Club'
    }
  ];

  return (
    <section className="leadership-page">
      {/* Header */}
      <div
        className={`leadership-hero ${visibleSections.has('header') ? 'visible' : ''}`}
        data-section="header"
        ref={(el) => (sectionRefs.current[0] = el)}
      >
        <div className="hero-cover-wrapper">
          <img src={imgLeaderCover} alt="Leadership Cover" className="hero-cover-img" />
          <div className="hero-overlay"></div>
        </div>
        
        <div className="hero-content">
          <h1 className="hero-title">Leadership & Organizations</h1>
          <p className="hero-subtitle">Roles and contributions in school clubs and college organizations</p>
        </div>
        
        <div className="hero-scroll-indicator">
          <div className="hero-mouse"></div>
        </div>
      </div>

      {/* Timeline Cards */}
      <div className="leadership-body">
        <div className="leadership-container">
          <div
            className={`leadership-timeline ${visibleSections.has('timeline') ? 'visible' : ''}`}
            data-section="timeline"
            ref={(el) => (sectionRefs.current[1] = el)}
          >
            <div className="lead-timeline-line"></div>
            {leadership.map((item, index) => (
              <div
                key={index}
                className="lead-item"
                style={{ animationDelay: `${index * 0.12}s` }}
              >
                <div className="lead-dot">
                  {item.icon}
                </div>
                <div className="lead-card">
                  <div className="lead-card-top">
                    <span className="lead-type-badge">{item.type}</span>
                    <span className="lead-year">{item.year}</span>
                  </div>
                  <h3 className="lead-position">{item.position}</h3>
                  <h4 className="lead-org">{item.organization}</h4>
                  <p className="lead-desc">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Leadership;
